<template>
  <div :class="className">
    <div class="spinner"></div>
    <img src="../../assets/themes/clippFacil/images/imageLoader.png" />
    <div class="loader-text">Carregando</div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    insideComponent: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    className() {
      const className = ['loader'];

      if (this.insideComponent) {
        className.push('inside-component');
      }

      return className.join(' ');
    },
  },
};
</script>
